import { DataSourceFilter } from '../../../components/data-source-filter-panel/data-source-filter-panel';

export const dataSourcePanelTitle = 'Data Source';

export const dataSourceFilterList: DataSourceFilter[] = [
  { id: 1, label: 'amazon.com', selected: true },
  { id: 2, label: 'amazon.co.uk', selected: true },
  { id: 3, label: 'amazon.de', selected: true },
  { id: 4, label: 'amazon.es', selected: true },
  { id: 5, label: 'amazon.fr', selected: true },
  { id: 6, label: 'amazon.it', selected: true },
  { id: 7, label: 'amazon.ca', selected: true },
  { id: 8, label: 'amazon.com.au', selected: true },
  { id: 9, label: 'amazon.in', selected: true },
  { id: 10, label: 'amazon.se', selected: true },
  { id: 11, label: 'amazon.ie', selected: true },
];
